// src/utils/knowledgeBaseHandlers.ts
import { NavigateFunction } from "react-router-dom";
import config from "../../config";
import { KnowledgeBaseData } from "./KnowledgeBaseTypes";
import { authFetch } from "../Security/authFetch";

const email = localStorage.getItem("email");

const postMessage = async (payload: any) => {
  return authFetch(`${config.apiBaseUrl}/api/messages`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(payload),
  });
};

export const handleEdit = async (
  data: KnowledgeBaseData,
  navigate: NavigateFunction,
  fetchMessages: () => void
) => {
  const username = localStorage.getItem("username") || "System";

  const payload = {
    username,
    message: `KnowledgeBase With Id ${data.ticketId} Edited.`,
    date: new Date().toISOString(),
    read: false,
    ticketId: data.ticketId,
  };

  try {
    const res = await postMessage(payload);
    if (res.ok) fetchMessages();
    else console.error("Failed to save message");
  } catch (e) {
    console.error("Error while saving message:", e);
  }

  navigate(`/knowledgeBase-edit/${data.ticketId}`, {
    state: { knowledgeBase: data },
  });
};

export const handleAccept = async (
  data: KnowledgeBaseData,
  fetchMessages: () => void
) => {
  const username = localStorage.getItem("username") || "System";
  const payload = {
    username,
    message: `KnowledgeBase With Id ${data.ticketId} Accepted.`,
    date: new Date().toISOString(),
    read: false,
    ticketId: data.ticketId,
  };

  try {
    const msgRes = await postMessage(payload);
    const updRes = await authFetch(
      `${config.apiBaseUrl}/api/knowledgeBases/${data.ticketId}/accept`,
      { method: "PUT" }
    );

    if (msgRes.ok && updRes.ok) {
      fetchMessages();
      window.location.reload();
    } else {
      console.error("Failed to accept or save message");
    }
  } catch (e) {
    console.error("Error while accepting knowledgeBase:", e);
  }
  if (data) {
    try {
      await authFetch(`${config.apiBaseUrl}/api/email/send`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },

        body: JSON.stringify({
          to: email,
          subject: ` ${data.ticketId}  – KnowledgeBase is in progress.`,
          body: `
    Customer: ${data.affectedCustomer} <br>
    Network: ${data.affectedNetwork} <br>
    Site: ${data.affectedSite} <br>
    Link: ${data.affectedLink} <br>
    Description: ${data.description} <br>

    Solution: ${data.solution} <br>
    <br>
    Regards, <br>
    
  `,
        }),
      });
      //console.log("Email sent successfully!");
    } catch (emailErr) {
      console.error("Failed to send email notification:", emailErr);
    }
  }
};

export const handleClose = async (
  data: KnowledgeBaseData,
  fetchMessages: () => void
) => {
  const username = localStorage.getItem("username") || "System";
  const payload = {
    username,
    message: `KnowledgeBase With Id ${data.ticketId} Closed.`,
    date: new Date().toISOString(),
    read: false,
    ticketId: data.ticketId,
  };

  try {
    const msgRes = await postMessage(payload);
    const updRes = await authFetch(
      `${config.apiBaseUrl}/api/knowledgeBases/${
        data.ticketId
      }/close?user=${encodeURIComponent(username)}`,

      {
        method: "PUT",
      }
    );
    if (data) {
      try {
        await authFetch(`${config.apiBaseUrl}/api/email/send`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },

          body: JSON.stringify({
            to: email,
            subject: `${data.ticketId}– KnowledgeBase is closed `,
            body: `
            Customer: ${data.affectedCustomer} <br>
            Network: ${data.affectedNetwork} <br>
            Site: ${data.affectedSite} <br>
            Link: ${data.affectedLink} <br>
            Description: ${data.description} <br>

            Solution: ${data.solution} <br>
            <br>
            Regards, <br>
            
          `,
          }),
        });
        //console.log("Email sent successfully!");
      } catch (emailErr) {
        console.error("Failed to send email notification:", emailErr);
      }
    }

    if (msgRes.ok && updRes.ok) {
      fetchMessages();
      window.location.reload();
    } else {
      console.error("Failed to Close or save message");
    }
  } catch (e) {
    console.error("Error while Closing knowledgeBase:", e);
  }
};

export const handlePause = async (
  data: KnowledgeBaseData,
  fetchMessages: () => void
) => {
  const username = localStorage.getItem("username") || "System";
  const payload = {
    username,
    message: `KnowledgeBase With Id ${data.ticketId} Paused.`,
    date: new Date().toISOString(),
    read: false,
    ticketId: data.ticketId,
  };

  try {
    const msgRes = await postMessage(payload);
    const updRes = await authFetch(
      `${config.apiBaseUrl}/api/knowledgeBases/${data.ticketId}/pause`,
      {
        method: "PUT",
      }
    );

    if (msgRes.ok && updRes.ok) {
      fetchMessages();
      window.location.reload();
    } else {
      console.error("Failed to Pause or save message");
    }
  } catch (e) {
    console.error("Error while Pausing knowledgeBase:", e);
  }
  if (data) {
    try {
      await authFetch(`${config.apiBaseUrl}/api/email/send`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },

        body: JSON.stringify({
          to: email,
          subject: `${data.ticketId} – KnowledgeBase is put on hold`,
          body: `
            Customer: ${data.affectedCustomer} <br>
            Network: ${data.affectedNetwork} <br>
            Site: ${data.affectedSite} <br>
            Link: ${data.affectedLink} <br>
            Description: ${data.description} <br>
            Solution: ${data.solution} <br>
            <br>
            Regards, <br>
            
          `,
        }),
      });
      //console.log("Email sent successfully!");
    } catch (emailErr) {
      console.error("Failed to send email notification:", emailErr);
    }
  }
};

export const handleReactivate = async (
  data: KnowledgeBaseData,
  fetchMessages: () => void
) => {
  const username = localStorage.getItem("username") || "System";
  const payload = {
    username,
    message: `KnowledgeBase With Id ${data.ticketId} Reactivated.`,
    date: new Date().toISOString(),
    read: false,
    ticketId: data.ticketId,
  };

  try {
    const msgRes = await postMessage(payload);
    const updRes = await authFetch(
      `${config.apiBaseUrl}/api/knowledgeBases/${data.ticketId}/reactivate`,
      { method: "PUT" }
    );

    if (msgRes.ok && updRes.ok) {
      fetchMessages();
      window.location.reload();
    } else {
      console.error("Failed to Reactivate or save message");
    }
  } catch (e) {
    console.error("Error while Reactivating knowledgeBase:", e);
  }
  if (data) {
    //console.log("emaaaaaaiiiiiiiiiiilllllllllllllll", email);
    try {
      await authFetch(`${config.apiBaseUrl}/api/email/send`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },

        body: JSON.stringify({
          to: email,
          subject: `${data.ticketId}– KnowledgeBase is reactivated.`,
          body: `
            Customer: ${data.affectedCustomer} <br>
            Network: ${data.affectedNetwork} <br>
            Site: ${data.affectedSite} <br>
            Link: ${data.affectedLink} <br>
            Description: ${data.description} <br>
            Solution: ${data.solution} <br>
            <br>
            Regards, <br>
            
          `,
        }),
      });
      //console.log("Email sent successfully!");
    } catch (emailErr) {
      console.error("Failed to send email notification:", emailErr);
    }
  }
};

export const handleReopen = async (
  data: KnowledgeBaseData,
  fetchMessages: () => void
) => {
  const username = localStorage.getItem("username") || "System";
  const payload = {
    username,
    message: `KnowledgeBase With Id ${data.ticketId} Reopened.`,
    date: new Date().toISOString(),
    read: false,
    ticketId: data.ticketId,
  };

  try {
    const msgRes = await postMessage(payload);
    const updRes = await authFetch(
      `${config.apiBaseUrl}/api/knowledgeBases/${data.ticketId}/reopen`,
      { method: "PUT" }
    );

    if (msgRes.ok && updRes.ok) {
      fetchMessages();
      window.location.reload();
    } else {
      console.error("Failed to Reactivate or save message");
    }
  } catch (e) {
    console.error("Error while Reactivating knowledgeBase:", e);
  }
  if (data) {
    try {
      await authFetch(`${config.apiBaseUrl}/api/email/send`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },

        body: JSON.stringify({
          to: email,
          subject: "KnowledgeBase Reopened",
          body: `An knowledgeBase with ID ${data.ticketId} has been Reopened.`,
        }),
      });
      //console.log("Email sent successfully!");
    } catch (emailErr) {
      console.error("Failed to send email notification:", emailErr);
    }
  }
};
